import React from 'react'
import PropTypes from 'prop-types'
import Checkbox from '../../../form/component/Checkbox'
import { ROLE_LIST_EMPLOYEE, ROLE_LIST_PARTNER } from '../../state/auth/const'


const RoleAdmin = ({ currentUser, toggleRole, saveUser }) => {
    const roleList = currentUser.employee ? ROLE_LIST_EMPLOYEE : ROLE_LIST_PARTNER
    return (
        <div>
            Assigned roles<br/>
            {
                roleList.map(role => {
                    const hasRole = currentUser.roleList.indexOf(role) !== -1
                    return (
                        <Checkbox
                            key={role}
                            object={{ hasRole }}
                            onChange={() => {
                                toggleRole(role, !hasRole)
                                saveUser()
                            }}
                            name="hasRole">{role}
                        </Checkbox>)
                })
            }
        </div>)
}


RoleAdmin.propTypes = {
    currentUser: PropTypes.object,
    toggleRole: PropTypes.func.isRequired,
    saveUser: PropTypes.func.isRequired,
}

export default RoleAdmin




// WEBPACK FOOTER //
// ./src/modules/security/component/manage/RoleAdmin.js